import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withAuth } from '@okta/okta-react';
import './Home.css';

class Home extends Component {
  state = {
    authenticated: null,
    profile: null,
    error: null,
    firstName: '',
    lastName: '',
    email: '',
    department: '',
    password: '',
    formErrors: {
      firstName: '',
      lastName: '',
      email: '',
      department: '',
      password: ''
    },
    showForm: false 
  };

  checkAuthentication = async () => {
    const authenticated = await this.props.auth.isAuthenticated();
    if (authenticated !== this.state.authenticated) {
      this.setState({ authenticated });
      if (authenticated) {
        this.fetchProfile();
      }
    }
  };

  fetchProfile = async () => {
    const id = localStorage.getItem("userID");
    try {
      const accessToken = await this.props.auth.getAccessToken();
      const response = await fetch(`https://dev-95143253.okta.com/api/v1/users/${id}`, {
        headers: {
          Authorization: `SSWS 00zk5kIxhdOOkmG10yK89JvP4UArceMemDf51_pXYM`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching profile: ${response.statusText}`);
      }

      const profileData = await response.json(); 
      this.setState({ profile: profileData }); 
    } catch (error) {
      this.setState({ error: error.toString() });
    }
  };

  async componentDidMount() {
    this.checkAuthentication();
  }

  async componentDidUpdate() {
    this.checkAuthentication();
  }

  login = async () => {
    this.props.auth.login('/');
  };

  logout = async () => {
    this.props.auth.logout('/');
  };

  viewProfiles = () => {
    this.props.history.push('/profiles');
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      formErrors: {
        ...this.state.formErrors,
        [name]: value ? value.length === '' : 'Field should not be empty'
      }
    });
  };

  resetForm = () => {
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      department: '',
      password: '',
      formErrors: {
        firstName: '',
        lastName: '',
        email: '',
        department: '',
        password: ''
      }
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { firstName, lastName, email, department, password} = this.state;

    if (!firstName || !lastName || !email || !department || !password) {
      this.setState({
        formErrors: {
          firstName: !firstName ? 'Field should not be empty' : '',
          lastName: !lastName ? 'Field should not be empty' : '',
          email: !email ? 'Field should not be empty' : '',
          department: !department ? 'Field should not be empty' : '',
          password: !password ? 'Field should not be empty' : ''
        }
      });
    } else {
      try {
        const accessToken = await this.props.auth.getAccessToken();
        const response = await fetch('https://believapi.ezinnovation.com/api/createUser', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `SSWS 00zk5kIxhdOOkmG10yK89JvP4UArceMemDf51_pXYM`
          },
          body: JSON.stringify({
            profile: {
              firstName,
              lastName,
              email,
              login: email,
              department
            },
            credentials: {
              password: { value: password }
            }
          }),
        });

        if (!response.ok) {
          throw new Error(`Error submitting form: ${response.statusText}`);
        }

        const result = await response.json();
        alert('User added successfully!');
        this.resetForm();
        this.setState({ showForm: false });
      } catch (error) {
        this.setState({ error: error.toString() });
      }
    }
  };

  toggleForm = () => {
    if (this.state.showForm) {
      this.resetForm();
    }
    this.setState((prevState) => ({ showForm: !prevState.showForm }));
  };

  navigateToOktaUsers = () => {
    this.props.history.push('/okta-users');
  };

  navigateToBelieveUsers = () => {
    this.props.history.push('/believe-users');
  };

  render() {
    if (this.state.authenticated === null) return null;

    const { authenticated, profile, error, firstName, lastName, email, department, password, formErrors, showForm } = this.state;

    const mainContent = authenticated ? (
      <div className='Maindiv'>
        <p className="lead">
          You have entered the Believ portal{' '}
        </p>
        {
          profile && profile.profile.department === "customer" ?
          <h3>Welcome to Customer</h3> : null
        }
        {
          profile && profile.profile.department === "admin" ?
          <h3>Welcome to Admin</h3> : null
        }
        {
          profile && profile.profile.department === "super admin" ?
          <h3>Welcome to Super Admin</h3> : null
        }
        {error && <p>Error fetching profile: {error}</p>}
        
        {profile && profile.profile ? (
          <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
            <div>
              <h2>Profile Details</h2>
              <p><strong>FirstName:</strong> {profile.profile.firstName}</p>
              <p><strong>LastName:</strong> {profile.profile.lastName}</p>
              <p><strong>Email:</strong> {profile.profile.email}</p>
              <p><strong>Login:</strong> {profile.profile.login}</p>
              <p><strong>Department:</strong> {profile.profile.department}</p>
              <p><strong>Status:</strong> {profile.status}</p>
              <p><strong>Created:</strong> {new Date(profile.created).toLocaleString()}</p>
              <p><strong>Last Login:</strong> {new Date(profile.lastLogin).toLocaleString()}</p>
            </div>
            {
              profile && profile.profile.department === "super admin" ? (
                <div className='form'>
                  {!showForm && (
                    <button onClick={this.toggleForm} className="btn btn-dark btn-lg">
                      Add User
                    </button>
                  )}
                  {showForm && (
                    <div className="form-container" style={{ position: 'relative' }}>
                      <button 
                        onClick={this.toggleForm} 
                        style={{
                          position: 'absolute',
                          top: '10px',
                          right: '10px',
                          background: 'transparent',
                          border: 'none',
                          fontSize: '20px',
                          cursor: 'pointer'

                        }}
                      >
                        &times;
                      </button>
                      <form onSubmit={this.handleSubmit}>
                        <div>
                          <label>
                            First Name:
                            <input 
                              type="text" 
                              name="firstName" 
                              value={firstName} 
                              onChange={this.handleInputChange} 
                              className="form-input"
                            />
                          </label>
                          {formErrors.firstName && <p className="error">{formErrors.firstName}</p>}
                          <label>
                            Last Name:
                            <input 
                              type="text" 
                              name="lastName" 
                              value={lastName} 
                              onChange={this.handleInputChange} 
                              className="form-input"
                            />
                          </label>
                          {formErrors.lastName && <p className="error">{formErrors.lastName}</p>}
                          <label>
                            Email:
                            <input 
                              type="email" 
                              name="email" 
                              value={email} 
                              onChange={this.handleInputChange} 
                              className="form-input"
                            />
                          </label>
                          {formErrors.email && <p className="error">{formErrors.email}</p>}
                          <label>
                            Password:
                            <input 
                              type="password" 
                              name="password" 
                              value={password} 
                              onChange={this.handleInputChange} 
                              className="form-input"
                            />
                          </label>
                          {formErrors.password && <p className="error">{formErrors.password}</p>}
                          <label>
                            Department:
                            <input 
                              type="text" 
                              name="department" 
                              value={department} 
                              onChange={this.handleInputChange} 
                              className="form-input"
                            />
                          </label>
                          {formErrors.department && <p className="error">{formErrors.department}</p>}
                        </div>
                        <div className="form-submit"
                        style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'flex-end'}}
                        >
                          <button type="submit" className="btn btn-dark btn-lg">Submit</button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              ) : null
            }
          </div>
        ) : (
          <p>Loading profile...</p>
        )}
        <button className="btn btn-light btn-lg" onClick={this.logout}>
          Logout
        </button>
        <button className="btn btn-dark btn-lg" style={{marginLeft:'15px'}} onClick={this.navigateToOktaUsers}>
          Okta Users
        </button>
        <button className="btn btn-dark btn-lg" style={{marginLeft:'15px'}} onClick={this.navigateToBelieveUsers}>
          Believe Users
        </button>
      </div>
    ) : (
      <div>
        <p className="lead">
          If you are a Believ member, please get your credentials from your
          supervisor
        </p>
        <button className="btn btn-dark btn-lg" onClick={this.login}>
          Login
        </button>
      </div>
    );

    return (
      <div className="jumbotron">
        <h1 className="display-4">Believ Portal</h1>
        {mainContent}
      </div>
    );
  }
}

export default withAuth(withRouter(Home));



// WEBPACK FOOTER //
// ./src/components/pages/Home.js